import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { ModalProps } from '../../../types/modal';

interface Props extends ModalProps {
    onSubmit: () => void;
}

const MarkAsCompletedModal = ({ open, onClose, onSubmit }: Props) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Mark as completed
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1}>
                    <Alert severity='warning'>
                        Please be advised that once you save, this action cannot
                        be undone
                    </Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onClose}>
                    Go Back
                </Button>
                <Button variant='contained' onClick={onSubmit}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MarkAsCompletedModal;
